import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Add Workstation route override
 *
 * @namespace routes.DeviceWorkstationFormAdd
 * @type {TmrRoute}
 */
let addRoute = {
  name: 'devices.workstations.add',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Profile.edit`],
}

/**
 * Edit Workstation route override
 *
 * @namespace routes.DeviceWorkstationFormEdit
 * @type {TmrRoute}
 */
let editRoute = {
  name: 'devices.workstations.view.edit',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Profile.edit`],
}

/**
 * Delete Workstation route override
 *
 * @namespace routes.DeviceWorkstationDelete
 * @type {TmrRoute}
 */
let deleteRoute = {
  name: 'devices.workstations.view.delete',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Profile.edit`],
}

export const routes = [addRoute, editRoute, deleteRoute]

/**
 * Workstation add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminWorkstationForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminWorkstationFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminWorkstationForm}.
 *
 * @type {ngController}
 */
export class tmrAdminWorkstationFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    ActiveWorkstation,
    Antenna,
    Place
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { ActiveWorkstation, Antenna, Place })
  }

  /** Query to get places for md-autocomplete. */
  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }

  /** Query to get antennas based on place&&description for md-autocomplete. */
  getAntennas(description) {
    return this.Antenna.free({
      'zone.place.id': this.resource.place.id,
      description,
    }).$promise
  }

  /** Add selected antenna to workstation antennas */
  addAntenna(antenna) {
    if (
      this.resource.antennas.find(({ id }) => id == antenna.id) === undefined
    ) {
      this.resource.antennas.push(antenna)
    }
    this.antenna = null
  }

  /**
   * Remove selected antenna from workstation antennas
   */
  removeAntenna({ id }) {
    this.resource.antennas = this.resource.antennas.filter(
      workstationAntenna => workstationAntenna.id != id
    )
  }

  /**
   * Place change event
   */
  onPlaceChange(place) {
    this.antennaText = ''
    if (
      place !== undefined &&
      this.resource.antennas &&
      this.resource.antennas.length &&
      place.id != this.resource.antennas[0].zone.place.id
    ) {
      this.resource.antennas.length = 0
    }
  }

  onSaved() {
    return this.ActiveWorkstation.get()
      .$promise.then(activeWorkstation => {
        if (this.resource.id == activeWorkstation.id)
          return this.ActiveWorkstation.set(this.resource)
      })
      .then(() => super.onSaved())
  }
}
